"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ShippingQuery = (0, graphql_tag_1.default) `
  fragment estimateError on EstimateErrorResponse {
    error
    status
    message
    uuid
  }

  fragment shippings on ShippingResponse {
    status
    shippings {
      id
      packages {
        deliveryTypes {
          id
          description
          type
          time
          price
        }
      }
    }
  }

  fragment estimate on EstimateResponse {
    disclaimers {
      sequence
      message
    }
    deliveries {
      closenessGroup {
        id
      }
      id
      status {
        code
      }
      modalities {
        id
        type
        name
        shippingTime {
          unit
          value {
            min
            max
          }
          description
          disclaimers {
            sequence
            message
          }
        }
        cost {
          customer
        }
        prices {
          customer
          operation
          currency
          exchangeRate
        }
      }
    }
    closenessGroups {
      customerCost
      disclaimer
      id
      items {
        seller {
          id
          sku
        }
      }
      name
      operationCost
      slug
      shortPolicy
      target
      targetRemaining
    }
    status
  }

  query shippingQuery($shippingRequest: ShippingRequest!) {
    shipping(shippingRequest: $shippingRequest) {
      status
      ...shippings
      ...estimate
      ...estimateError
    }
  }
`;
exports.default = ShippingQuery;
